import React from "react";
import Box from "@mui/material/Box";
import tipPng from "src/assets/images/Dumper_Tip.png"; // ✅ place your PNG in this folder

const DumperTipIcon = ({ size = 55, ...props }) => (
  <Box
    component="img"
    src={tipPng}
    alt="Drive Icon"
    sx={{
      width: size,
      height: size,
      display: "inline-block"
    }}
    {...props}
  />
);

export default DumperTipIcon;
